import {
  SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
  SET_EXIM_CARGO_TEMPLATE,
  SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
  SET_UPLOAD_SHIPMENT_DETAILS_LIST,
  TOAST_ERROR,
  TOAST_SUCCESS,
} from "Constants/actionConstants";
import {
  GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS_URL,
  GET_EXIM_CARGO_TEMPLATE_URL,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE_URL,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_URL,
  UPLOAD_EXIM_CARGO_TEMPLATE_URL,
  EXIM_ON_DEMAND_TRACKING_URL,
  SAVE_EXIM_CONTAINER_ADDITIONAL_FILES_SKU_DETAILS_URL
} from "Utils/api";
import axiosT1 from "Utils/axios";
import { call, put } from "redux-saga/effects";
import { getPresignedUrl } from "./common";

export function* getEximCargoTemplate(action) {
  try {
    const resData = yield call(
      axiosT1.get, 
      GET_EXIM_CARGO_TEMPLATE_URL, 
      { 
        params: action.data 
      }
    );
    const data = resData.data;
     const presignedUrlData = yield call(getPresignedUrl, {
            data,
      });
    const eximCargoTemplateFileUrl = presignedUrlData.url;

    // yield put({
    //   type: SET_EXIM_CARGO_TEMPLATE,
    //   payload: eximCargoTemplateFileUrl,
    // });
    if (!!action.onSuccess) {
      action.onSuccess(eximCargoTemplateFileUrl);
    }
  } catch (e) {
    const responseMessage = e.response.data && e.response.data.message
    yield put({
      type: TOAST_ERROR,
      message:  responseMessage ? responseMessage :"Oops! Something Went Wrong"
  });
  }
}

export function* uploadEximCargoTemplate(action) {
  try {
    const resData = yield call(
      axiosT1.post,
      UPLOAD_EXIM_CARGO_TEMPLATE_URL,
      action.payload
    );
    if (!!action.onSuccess) {
      action.onSuccess();
    }
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getEximContainerBlTrackingDetails(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_URL,
      {
        params: action.queryParams,
      }
    );
    const type = action.queryParams.type;
    const payload = resData.data.data.list;
    const trackingCount = resData.data.data.total_doc;
    yield put({
      type: SET_UPLOAD_SHIPMENT_DETAILS_LIST,
      payload: {
        type: type,
        payload: payload,
        trackingCount: trackingCount
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getEximCargoSourceDestinationPortAndStatus(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS_URL
    );
    const sourcePortList = resData.data.data.source_port.map((ele) => {
      return {
        label: ele,
        value: ele,
      };
    });
    const destinationPortList = resData.data.data.destination_port.map(
      (ele) => {
        return {
          label: ele,
          value: ele,
        };
      }
    );
    const statusList = resData.data.data.status.map((ele) => {
      return {
        ...ele,
        label: ele.name,
        value: ele.id,
      };
    });
    const blNumbers = resData.data.data.bl_number_list.map((ele) => {
      return {
        ...ele,
        label: ele.bl_number,
        value: ele.bl_number,
      };
    });
    const categoryList = resData.data.data.category_list.map((ele) => {
      return {
        ...ele,
        label: ele.name,
        value: ele.name,
      };
    });
    yield put({
      type: SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
      payload: {
        sourcePortList,
        destinationPortList,
        statusList,
        blNumbers,
        categoryList
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getEximContainerBlTrackingDetailsTemplate(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE_URL,
      {
        params: action.payload.queryParams,
      }
    );
    const data = resData.data;
     const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
    const eximContainerBlTrackingDetailsTemplateFileUrl =
      presignedUrlData.url;
    if (action.payload.isContainerNumberWise) {
      action.payload.onSuccessContainerNumberWise(
        eximContainerBlTrackingDetailsTemplateFileUrl
      );
    } else {
      yield put({
        type: SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
        payload: eximContainerBlTrackingDetailsTemplateFileUrl,
      });
    }
  } catch (e) {
    console.log("e:", e);
  }
}

export function* postOnDemandTracking(action) {
  try {
    const resData = yield call(
      axiosT1.post,
      EXIM_ON_DEMAND_TRACKING_URL,
      action.payload
    );
      yield put({
        type: TOAST_SUCCESS,
        message: (resData.data || {}).message
      })
    if (!!action.onSuccess) {
      action.onSuccess();
    }
  } catch (e) {
    console.log("e:", e);
  }
}

export function* saveEximCargoDetailsSkuDetails(action) {
  try {
   const data  =  yield call(axiosT1.put, 
    SAVE_EXIM_CONTAINER_ADDITIONAL_FILES_SKU_DETAILS_URL,
    action.payload);
   const message = data.data.message || ""
   yield put({
      type: TOAST_SUCCESS,
      message: !!message?message:"Data updated successfully!!"
  });

    if(action.onSuccess){
      action.onSuccess()
    }

  } catch (e) {
    
  }
}
